import { DirectoryChargeTotal, DirectoryPartySummary } from '../models/shipment-directory.model';

const chargeTypes = [
    'TRANSPORT', 'WAITING', 'LABOR', 'CUSTOMS_CLEARANCE', 'DAMAGED_GOODS',
    'MULTIPLE_DROPOFF', 'FUEL', 'TOLL', 'LOADING_CHARGES', 'DOCUMENTATION',
    'INSURANCE', 'MISCELLANEOUS'
];

export interface ChargeColumn {
    type: string;
    currencyCode: string;
    buyingHeader: string;
    sellingHeader: string;
}

export function exportPartyNames(row: {
    crmClient?: DirectoryPartySummary;
    crmAccount?: DirectoryPartySummary;
    crmClientContact?: DirectoryPartySummary;
    mainParty?: DirectoryPartySummary;
    subParty?: DirectoryPartySummary;
}): Record<string, string> {
    return {
        'CRM Client': row.crmClient?.name || row.mainParty?.name || '',
        'Client Account': row.crmClient ? row.crmAccount?.name || '' : '',
        'Client Contact': row.crmClient ? row.crmClientContact?.name || '' : row.subParty?.name || ''
    };
}

export function chargeColumns(rows: { chargeTotals?: DirectoryChargeTotal[] }[]): ChargeColumn[] {
    const seen = new Set(rows.flatMap(row => (row.chargeTotals ?? [])
        .map(total => `${total.type}|${total.currencyCode}`)));
    return [...seen].map(key => {
        const [type, currencyCode] = key.split('|');
        const label = type === 'TRANSPORT' ? 'Additional Transport'
            : type.toLowerCase().split('_').map(word => word[0].toUpperCase() + word.slice(1)).join(' ');
        return { type, currencyCode,
            buyingHeader: `${label} Buying (${currencyCode})`,
            sellingHeader: `${label} Selling (${currencyCode})` };
    }).sort((left, right) => (chargeTypes.indexOf(left.type) < 0 ? chargeTypes.length : chargeTypes.indexOf(left.type))
        - (chargeTypes.indexOf(right.type) < 0 ? chargeTypes.length : chargeTypes.indexOf(right.type))
        || left.currencyCode.localeCompare(right.currencyCode));
}

export function chargeCells(row: { chargeTotals?: DirectoryChargeTotal[] }, columns: ChargeColumn[]): Record<string, number | string> {
    const totals = new Map((row.chargeTotals ?? []).map(total => [`${total.type}|${total.currencyCode}`, total]));
    const cells: Record<string, number | string> = {};
    for (const column of columns) {
        const total = totals.get(`${column.type}|${column.currencyCode}`);
        cells[column.buyingHeader] = total?.buyingAmount ?? '';
        cells[column.sellingHeader] = total?.sellingAmount ?? '';
    }
    return cells;
}
